/** 
 * Fetches all applications from the backend API.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Array>} - A promise that resolves to the list of applications.
 */
export const fetchAllApplicationsMain = async (token) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = '/ros_be_app_directory/applications';
        //const url = 'http://localhost:5000/ros_be_app_directory/applications';
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error(`Error fetching applications: [${response.status}] [${response.statusText}]`);
        }

        const apps = await response.json();
        return apps.map((app) => ({
          ...app,
          //image: `http://localhost:5000/ros_be_app_directory/applications/${app.id}/image`,
          image: `/ros_be_app_directory/applications/${app.id}/image`, 
        }));    
    } catch (error) {
        console.error("Error fetching applications:", error);
        throw error;
    }
};

/** 
 * Fetches all applications from the backend API based on visibility.
 * @param {string} token - The access token for authentication (optional).
 * @param {string} email - email address
 * @returns {Promise<Array>} - A promise that resolves to the list of applications.
 */
export const fetchApplications = async (token,email) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = `/ros_be_app_directory/applications/visibility/${email}`;
        //const url = `http://localhost:5000/ros_be_app_directory/applications/visibility/${email}`;
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error(`Error fetching applications: [${response.status}] [${response.statusText}]`);
        }

        const apps = await response.json();
        return apps.map((app) => ({
          ...app,
          //image: `http://localhost:5000/ros_be_app_directory/applications/${app.id}/image`,
          image: `/ros_be_app_directory/applications/${app.id}/image`, 
        }));    
    } catch (error) {
        console.error("Error fetching applications:", error);
        throw error;
    }
};

/**
 * Fetches a single application by its ID.
 * @param {string} id - The ID of the application to fetch.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to the application object.
 */
export const fetchApplicationById = async (id, token) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = `/ros_be_app_directory/applications/${id}`;
        //const url = `http://localhost:5000/ros_be_app_directory/applications/${id}`;
        const response = await fetch(url, { method: 'GET', headers });

        if (!response.ok) {
            throw new Error(`Error fetching application with ID ${id}: [${response.status}] [${response.statusText}]`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error fetching application with ID ${id}:`, error);
        throw error;
    }
};

/**
 * Creates a new application in the backend.
 * @param {Object} applicationData - The data for the new application.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to the created application object.
 */
export const createApplication = async (applicationData, token) => { 
    try {
      const headers = new Headers();
      if (token) headers.append('Authorization', `Bearer ${token}`);
      const url = '/ros_be_app_directory/applications';
      //const url = 'http://localhost:5000/ros_be_app_directory/applications';
      const response = await fetch(url, {
        method: 'POST',
        headers, 
        body: applicationData, 
      });
  
      if (!response.ok) {
        throw new Error(`Error creating application: [${response.status}] [${response.statusText}]`);
      }
  
      return response;
    } catch (error) {
      console.error("Error creating application:", error);
      throw error;
    }
  };
  

/**
 * Updates an existing application in the backend.
 * @param {string} id - The ID of the application to update.
 * @param {Object} applicationData - The updated data for the application.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to the updated application object.
 */
export const updateApplication = async (id, applicationData, token) => {
    try {
      const headers = new Headers();
      if (token) headers.append('Authorization', `Bearer ${token}`);
      const url = `/ros_be_app_directory/applications/${id}`;
      //const url = `http://localhost:5000/ros_be_app_directory/applications/${id}`;
      const response = await fetch(url, {
        method: 'PUT',
        headers, 
        body: applicationData, 
      });
  
      if (!response.ok) {
        throw new Error(`Error updating application with ID ${id}: [${response.status}] [${response.statusText}]`);
      }
  
      return response;
    } catch (error) {
      console.error(`Error updating application with ID ${id}:`, error);
      throw error;
    }
  };
  

/**
 * Deletes an application by its ID.
 * @param {string} id - The ID of the application to delete.
 * @param {string} token - The access token for authentication (optional).
 * @returns {Promise<Object>} - A promise that resolves to a success message.
 */
export const deleteApplication = async (id, token) => {
    try {
        const headers = new Headers();
        if (token) headers.append('Authorization', `Bearer ${token}`);
        const url = `/ros_be_app_directory/applications/${id}`;
        //const url = `http://localhost:5000/ros_be_app_directory/applications/${id}`;
        const response = await fetch(url, { method: 'DELETE', headers });

        if (!response.ok) {
            throw new Error(`Error deleting application with ID ${id}: [${response.status}] [${response.statusText}]`);
        }

        return await response.json();
    } catch (error) {
        console.error(`Error deleting application with ID ${id}:`, error);
        throw error;
    }
};

